export function getChatWebSocketUrl() {
  const base = process.env.REACT_APP_DEV_API_BASE || "";
  const path = "/ws";
  const url = new URL(base);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  url.pathname = path;
  return url.toString();
}
